<template>
  <el-select
    ref="el-select"
    v-model="search"
    filterable
    remote
    clearable
    :placeholder="placeholder"
    class="app-medication-search"
    :loading="loading"
    :disabled="disabled"
    :remote-method="handleRemoteSearch"
    @input="handleItemSelect">
    <el-option
      v-for="medication in formattedMedications"
      :key="`${medication.tagClass}-${medication.reference}`"
      :label="medication.display"
      :value="medication.reference"
      :class="{ 'app-medication-select__option--recommended': medication.recommended }">
      <div class="app-medication-search__item">
        <span class="app-medication-search__item-title">{{ medication.display }}</span>
        <el-tag class="app-medication-search__item-type" :class="[medication.tagClass]">
          {{ medication.tagName }}
        </el-tag>
      </div>
    </el-option>
  </el-select>
</template>
<script>
import _kebabCase from 'lodash/kebabCase';
export default {
  name: 'AppMedicationSearch',
  props: {
    value: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    medications: {
      type: Array,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Buscar medicamento'
    }
  },
  data() {
    return {
      search: this.value.display || ''
    };
  },
  computed: {
    formattedMedications() {
      return this.medications.map(m => {
        const tagName = m.original.nombreCategoria.replace('Fármacos - ', '').replace('Medicamento', 'Med.');
        const tagClass = `app-medication-search__item-type--${_kebabCase(tagName)}`;
        return {
          display: m.display,
          reference: m.reference,
          recommended: m.recommended,
          nombreCategoria: m.original.nombreCategoria,
          tagName,
          tagClass
        };
      });
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue.reference !== oldValue.reference) {
        this.search = newValue.display;
      }
    }
  },
  mounted() {
    document.getElementById('medication-search').getElementsByClassName('el-input__inner')[0].focus();
  },
  methods: {
    handleRemoteSearch(value) {
      this.$emit('search', value);
    },
    handleItemSelect(value) {
      value = value ? JSON.parse(JSON.stringify(this.medications.find(m => m.reference === value))) : '';
      this.$emit('input', value);
    }
  }
};
</script>
<style lang="scss">
.app-medication-search {
  &__item {
    max-width: 70vw;
    display: flex;
    justify-content: space-between;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
    }

    &-title {
      max-width: 80%;
    }

    &-type {
      text-align: right;

      &--med-clinico {
        background-color: #f0f9eb;
        border-color: #e1f3d8;
        color: #67c23a;
      }

      &--med-basico {
        background-color: #fef0f0;
        border-color: #fde2e2;
        color: #f56c6c;
      }
    }
  }
}
</style>
